import { EMPTY_OBJECT } from '../../../constants/common'
import { DEFAULT_TIME_ZONE } from '../../../constants/date'
import { createNowDateInUkTimezone } from '../../../utils/date'
import { generateSentence } from '../../../utils/generate'
import { ChatTableCellName } from '../../Chat'
import { getTableVisibleColumns } from '../../Table'

const TABLE_ROW_LABELS = [
  {
    color: {
      id: 24,
      value: '#00e58a',
    },
    id: 1419,
    name: 'Tatooine',
  },
  {
    color: {
      id: 23,
      value: '#006fbb',
    },
    id: 1418,
    name: 'Discworld',
  },
  {
    color: {
      id: 25,
      value: '#ff75cb',
    },
    id: 1420,
    name: 'Matrix',
  },
]

const TABLE_ROW_SERVICE_REQUEST_PENDING = {
  archived: false,
  id: 1,
  request_no: 1,
  status: 1,
  title: 'First service request',
}

const TABLE_ROW_SERVICE_REQUEST_IN_PROGRESS = {
  archived: false,
  id: 2,
  request_no: 2,
  status: 2,
  title: 'Second service request',
}

const REQUESTS = [
  TABLE_ROW_SERVICE_REQUEST_PENDING,
  TABLE_ROW_SERVICE_REQUEST_IN_PROGRESS,
]

const USER = {
  avatar: null,
  avatar_color: '#DBC27F',
  fullname: 'Vasiliy Ivanovich very long name',
  id: 0,
}

const USER_1 = {
  avatar: null,
  avatar_color: '#FFF65F',
  email: 'johndoe@gmail.com',
  fullname: 'John Doe',
  id: 1,
}

const USER_2 = {
  avatar: null,
  avatar_color: '#ACC81F',
  fullname: 'Zigmund Freid',
  id: 2,
}

const now = createNowDateInUkTimezone(DEFAULT_TIME_ZONE).toISOString()

const LAST_MESSAGE = {
  created: now,
  deleted: false,
  files: [],
  owner: USER,
  text: generateSentence(10, 5),
}

const PARTICIPANTS = [USER, USER_1, USER_2]

const BUILDING = {
  id: 0,
  title: 'WG101 Theresiengasse 35, 1180 Wien, Austria',
}

const BUILDING_1 = {
  id: 1,
  title: 'WG101 Theresiengasse 35, 1180 Berlin, Germany',
}

const BUILDING_2 = {
  id: 2,
  title: 'WG101 Theresiengasse 35, 1180 Praga, Chech Republic',
}

const BUILDINGS = [BUILDING, BUILDING_1, BUILDING_2]

export const TABLE_ROW_COLUMNS_CONFIG = {
  buildings: {
    index: 4,
    name: ChatTableCellName.Buildings,
    ordering_field: null,
    title: 'Chats.BuildingsColumnTitleKey',
    visible: true,
    width: 416,
  },
  created: {
    index: 9,
    name: ChatTableCellName.Created,
    ordering_field: null,
    title: 'Chats.CreatedColumnTitleKey',
    visible: true,
    width: 200,
  },
  created_by: {
    index: 8,
    name: ChatTableCellName.CreatedBy,
    ordering_field: null,
    title: 'Chats.CreatedByColumnTitleKey',
    visible: true,
    width: 240,
  },
  last_message: {
    index: 1,
    name: ChatTableCellName.LastMessage,
    ordering_field: null,
    title: 'Chats.LastMessageColumnTitleKey',
    visible: true,
    width: 556,
  },
  last_message_date: {
    index: 2,
    name: ChatTableCellName.LastMessageDate,
    ordering_field: null,
    title: 'Chats.LastMessageDateColumnTitleKey',
    visible: true,
    width: 200,
  },
  participants: {
    index: 3,
    name: ChatTableCellName.Participants,
    ordering_field: null,
    title: 'Chats.ParticipantsColumnTitleKey',
    visible: true,
    width: 240,
  },
  requests: {
    index: 5,
    name: ChatTableCellName.Requests,
    ordering_field: null,
    title: 'Chats.RequestsColumnTitleKey',
    visible: true,
    width: 280,
  },
  title: {
    index: 0,
    name: ChatTableCellName.Title,
    ordering_field: null,
    title: 'Chats.TitleColumnTitleKey',
    visible: true,
    width: 252,
  },
  updated: {
    index: 7,
    name: ChatTableCellName.Updated,
    ordering_field: null,
    title: 'Chats.UpdatedColumnTitleKey',
    visible: true,
    width: 200,
  },
  updated_by: {
    index: 6,
    name: ChatTableCellName.UpdatedBy,
    ordering_field: null,
    title: 'Chats.UpdatedByColumnTitleKey',
    visible: true,
    width: 240,
  },
}

export const TABLE_ROW_VISIBLE_COLUMNS = getTableVisibleColumns(
  TABLE_ROW_COLUMNS_CONFIG
)

export function getTableRowData(data) {
  const now = createNowDateInUkTimezone(DEFAULT_TIME_ZONE).toISOString()

  const {
    buildings = BUILDINGS,
    created = now,
    created_by = USER_1,
    labels = TABLE_ROW_LABELS,
    last_message = LAST_MESSAGE,
    requests = REQUESTS,
    title = generateSentence(3, 5),
    unread_messages_count = 10,
    updated = now,
    updated_by = USER_2,
    users = PARTICIPANTS,
  } = data || EMPTY_OBJECT

  return {
    buildings,
    created,
    created_by,
    labels,
    last_message,
    requests,
    title,
    unread_messages_count,
    updated,
    updated_by,
    users,
    uuid: 0,
  }
}
